import * as React from "react";
const SvgBeak = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 44, height: 6, fill: "#fff", stroke: "#fff", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m22 0-6 6h12z" }));
export default SvgBeak;
